import { render, staticRenderFns } from "./RateDialog.vue?vue&type=template&id=0daed7bb&scoped=true"
import script from "./RateDialog.vue?vue&type=script&lang=js"
export * from "./RateDialog.vue?vue&type=script&lang=js"
import style0 from "./RateDialog.vue?vue&type=style&index=0&id=0daed7bb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daed7bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0daed7bb')) {
      api.createRecord('0daed7bb', component.options)
    } else {
      api.reload('0daed7bb', component.options)
    }
    module.hot.accept("./RateDialog.vue?vue&type=template&id=0daed7bb&scoped=true", function () {
      api.rerender('0daed7bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/components/RateDialog.vue"
export default component.exports